import { useState } from "react";
import { FAQS } from "@/mocks/gossip";

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100 border-y border-background-200 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          {/* 左侧文字 */}
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-600 bg-accent-100 rounded-full px-3 py-1 mb-3">
              <i className="ri-questionnaire-line"></i> 围观指南
            </span>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
              关于吃瓜，你想知道的都在这里
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              围观也要讲分寸。我们整理了关于九一吃瓜最常见的问题，帮你更好地站上前排、理性吃瓜。
            </p>
            <div className="mt-6 flex items-center gap-3 rounded-2xl bg-secondary-50 border border-secondary-200 p-4">
              <span className="w-11 h-11 flex items-center justify-center rounded-2xl bg-secondary-500 text-background-50 shrink-0">
                <i className="ri-chat-smile-2-line text-xl"></i>
              </span>
              <p className="text-sm text-foreground-700">
                还有疑问？欢迎在下方联系板块留言，或直接给我们发邮件。
              </p>
            </div>
          </div>

          {/* 右侧 FAQ 折叠 */}
          <div className="lg:col-span-7">
            <div className="space-y-3">
              {FAQS.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div
                    key={i}
                    className="rounded-2xl bg-background-50 border border-background-200 overflow-hidden"
                  >
                    <button
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="text-sm md:text-base font-medium text-foreground-900">
                        {f.q}
                      </span>
                      <span className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                      } transition`}>
                        <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"}`}></i>
                      </span>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ${
                        isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                          {f.a}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}